import { render, staticRenderFns } from "./AudienceDateInput.vue?vue&type=template&id=68920c92"
import script from "./AudienceDateInput.vue?vue&type=script&lang=ts"
export * from "./AudienceDateInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports